import React from 'react';
import { formatCurrency } from 'utils/helpers';
import './dashboard-charts.css';

function PerformanceTable({ title, data, loading, metric, displayField = 'name' }) {
  return (
    <div className='chart-card merchants-card'>
      <div className='card-head'>
        <div className='card-title'>{title}</div>
        <div className='card-hint'>{metric === 'value' ? 'By value' : 'By count'}</div>
      </div>
      {loading ? (
        <div>
          <div className='skeleton skeleton-bar' style={{ width: '100%' }} />
          <div className='skeleton skeleton-bar' style={{ width: '95%' }} />
          <div className='skeleton skeleton-bar' style={{ width: '92%' }} />
          <div className='skeleton skeleton-bar' style={{ width: '90%' }} />
          <div className='skeleton skeleton-bar' style={{ width: '88%' }} />
        </div>
      ) : data.length === 0 ? (
        <div style={{ padding: '2rem 0', textAlign: 'center', color: '#666' }}>No records found for this period</div>
      ) : (
        <ul className='merchant-list ranked'>
          {data.map((item, i) => (
            <li key={item.id || i}>
              <span className='rank-badge'>{i + 1}</span>
              <span className='merchant-name'>{item[displayField] || item.name}</span>
              <span className='merchant-amount'>
                {metric === 'value' ? formatCurrency(item.total, 'NGN') : `${Number(item.total).toLocaleString()} txns`}
              </span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default PerformanceTable;
